var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/streamables.ts
import { onlyServer } from "@adornis/base/decorators/onlyServer.js";
import { Entity } from "@adornis/baseql/decorators.js";
import { stat } from "fs/promises";
import { pipeline } from "stream";
import { AdornisFile } from "./files.js";
var StreamableFile = class extends AdornisFile {
  static canHandleFile(retrievedFile) {
    return retrievedFile.mimetype.startsWith("audio") || retrievedFile.mimetype.startsWith("video");
  }
  static async _serveFileFromPath({
    request,
    response,
    fileID,
    path,
    contentType,
    options
  }) {
    const fileSize = (await stat(path).catch(() => ({ size: 0 }))).size;
    response.setHeader("Content-Type", contentType);
    const ranges = request.range(fileSize);
    if (!Array.isArray(ranges)) {
      response.setHeader("Content-Length", fileSize);
      return super._serveFileFromPath({ request, response, fileID, path, contentType, options });
    }
    const start = ranges[0].start;
    const end = ranges[0].end;
    response.setHeader("Content-Range", `bytes ${start}-${end}/${fileSize}`);
    response.setHeader("Content-Length", end - start + 1);
    response.writeHead(206);
    const opts = { start, end };
    pipeline(await this._readFromPath(path, opts), response, (err) => {
      if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE")
        console.warn(`PIPELINE WITH RANGE ERROR: (${path})`, err);
    });
  }
};
StreamableFile._class = "StreamableFile";
__decorateClass([
  onlyServer
], StreamableFile, "canHandleFile", 1);
__decorateClass([
  onlyServer
], StreamableFile, "_serveFileFromPath", 1);
StreamableFile = __decorateClass([
  Entity()
], StreamableFile);
export {
  StreamableFile
};
